/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GeneratedMutation } from "./GeneratedMutation";
export const GeneratedMutationResponse = core.serialization.object({
    data: GeneratedMutation,
});
